import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchDataViewSuccess = (data: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: data,
});

export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid };
            const apiname = donorapi.dneeds;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const viewdata = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { needid:Id};
            const apiname = donorapi.dview;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};